<script setup lang="ts">
  import { useNotes } from '@/store/notes';
  import { defineProps, onMounted, ref } from 'vue';
  import { localstorageGet, localstorageSet } from '@/helpers/helper';

  const NotesService = useNotes();
  const props = defineProps<{
    country: string;
  }>();
  onMounted(async () => {
    await NotesService?.getNotes(props.country);
  });
  const visibleNotes = ref<boolean>(!(localstorageGet('readNews') === 'true'));
</script>

<template>
  <Dialog
    v-model:visible="visibleNotes"
    header="Delivery Information"
    :style="{ width: '90%' }"
    :position="position"
    :modal="true"
    :closable="false"
    :draggable="false"
  >
    <div v-if="NotesService.notes.value?.value" class="overflow-y-auto h-[80%]">
      <div v-html="NotesService.notes.value?.value"></div>
    </div>
    <div v-else class="flex justify-center">
      <div
        class="animate-spin rounded-full h-8 w-8 border-t-4 border-b-4 border-teal-500"
      ></div>
    </div>
    <div class="flex justify-end gap-2">
      <Button
        type="button"
        label="Ok"
        @click="
          () => {
            visibleNotes = false;
            localstorageSet('readNews', true);
          }
        "
      ></Button>
    </div>
  </Dialog>
  <!--  <div-->
  <!--    class="p-2 mt-4 bg-white dark:border-gray-800 rounded-md shadow-md text-stone-950"-->
  <!--  >-->
  <!--    <div>-->
  <!--      <b>Additional payment timers</b>-->
  <!--      <div>Additives that require bulk addition prior to delivery in calc.</div>-->
  <!--    </div>-->
  <!--    <div-->
  <!--      class="break-words"-->
  <!--      v-if="openInfo"-->
  <!--      v-html="NotesService.notes.value?.value"-->
  <!--    ></div>-->
  <!--    <div class="my-2" v-if="!NotesService.isLoading.value">-->
  <!--      <button-->
  <!--        class="bg-zinc-100 p-4 w-full flex items-start justify-center text-black font-bold rounded-md"-->
  <!--        v-if="!openInfo"-->
  <!--        @click="openInfo = true"-->
  <!--      >-->
  <!--        <span class="mr-2">Review all changes</span>-->
  <!--        <svg-->
  <!--          width="17"-->
  <!--          height="18"-->
  <!--          viewBox="0 0 17 18"-->
  <!--          fill="none"-->
  <!--          xmlns="http://www.w3.org/2000/svg"-->
  <!--        >-->
  <!--          <path-->
  <!--            d="M8.49996 15.5521C8.36538 15.5521 8.23079 15.5025 8.12454 15.3963L3.82496 11.0967C3.61954 10.8913 3.61954 10.5513 3.82496 10.3458C4.03038 10.1404 4.37038 10.1404 4.57579 10.3458L8.49996 14.27L12.4241 10.3458C12.6295 10.1404 12.9695 10.1404 13.175 10.3458C13.3804 10.5513 13.3804 10.8913 13.175 11.0967L8.87538 15.3963C8.76913 15.5025 8.63454 15.5521 8.49996 15.5521Z"-->
  <!--            fill="#292D32"-->
  <!--          />-->
  <!--          <path-->
  <!--            d="M8.5 15.4317C8.20958 15.4317 7.96875 15.1909 7.96875 14.9004V2.97919C7.96875 2.68877 8.20958 2.44794 8.5 2.44794C8.79042 2.44794 9.03125 2.68877 9.03125 2.97919V14.9004C9.03125 15.1909 8.79042 15.4317 8.5 15.4317Z"-->
  <!--            fill="#292D32"-->
  <!--          />-->
  <!--        </svg>-->
  <!--      </button>-->
  <!--      <button-->
  <!--        class="bg-zinc-100 p-4 w-full flex items-start justify-center text-black font-bold rounded-md"-->
  <!--        v-else-->
  <!--        @click="openInfo = false"-->
  <!--      >-->
  <!--        <span class="mr-2">Hide full changes</span>-->
  <!--        <svg-->
  <!--          width="18"-->
  <!--          height="18"-->
  <!--          viewBox="0 0 18 18"-->
  <!--          fill="none"-->
  <!--          xmlns="http://www.w3.org/2000/svg"-->
  <!--        >-->
  <!--          <path-->
  <!--            d="M9.00004 2.44779C9.13462 2.44779 9.26921 2.49738 9.37546 2.60363L13.675 6.90321C13.8805 7.10863 13.8805 7.44863 13.675 7.65404C13.4696 7.85946 13.1296 7.85946 12.9242 7.65404L9.00004 3.72988L5.07587 7.65404C4.87046 7.85946 4.53046 7.85946 4.32504 7.65404C4.11962 7.44863 4.11962 7.10863 4.32504 6.90321L8.62462 2.60363C8.73087 2.49738 8.86546 2.44779 9.00004 2.44779Z"-->
  <!--            fill="#292D32"-->
  <!--          />-->
  <!--          <path-->
  <!--            d="M9 2.56825C9.29042 2.56825 9.53125 2.80909 9.53125 3.0995L9.53125 15.0208C9.53125 15.3112 9.29042 15.552 9 15.552C8.70958 15.552 8.46875 15.3112 8.46875 15.0208L8.46875 3.0995C8.46875 2.80909 8.70958 2.56825 9 2.56825Z"-->
  <!--            fill="#292D32"-->
  <!--          />-->
  <!--        </svg>-->
  <!--      </button>-->
  <!--    </div>-->
  <!--    <div v-else class="flex justify-center">-->
  <!--      <div-->
  <!--        class="animate-spin rounded-full h-8 w-8 border-t-4 border-b-4 border-teal-500"-->
  <!--      ></div>-->
  <!--    </div>-->
  <!--  </div>-->
</template>
